/**
Author - Pradip Dhakal
Git - https://github.com/pradipwealthy
**/

import UploadIdsContainer from "./UploadIds.container";
export default UploadIdsContainer;